var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/size-guide/fit-size-guide.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row o-column o-extra-small--12\">\n\n    <div class=\"s-cms\">\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sizeGuide")),"selectedUnit") == "Inches") {
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedFit")),"sizeGuideInches")) {
output += "\n                ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedFit")),"sizeGuideInches")), env.opts.autoescape);
output += "\n            ";
;
}
output += "\n\n        ";
;
}
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sizeGuide")),"selectedUnit") == "Centimeters") {
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedFit")),"sizeGuideCentimeters")) {
output += "\n                ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedFit")),"sizeGuideCentimeters")), env.opts.autoescape);
output += "\n            ";
;
}
output += "\n\n        ";
;
}
output += "\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/size-guide/fit-size-guide.j2"] , dependencies)